/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { DeleteMediaResponse } from '../model/deleteMediaResponse';
import { DownloadMediaFileResponse } from '../model/downloadMediaFileResponse';
import { GetMediaFilesResponse } from '../model/getMediaFilesResponse';
import { MediaFile } from '../model/mediaFile';
import { MediaFileForm } from '../model/mediaFileForm';
import { MediaLanguagesResponse } from '../model/mediaLanguagesResponse';
import { MultipartFormDataInput } from '../model/multipartFormDataInput';
import { Response } from '../model/response';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { MediaAdministrationServiceInterface }                            from './mediaAdministration.serviceInterface';


@Injectable()
export class MediaAdministrationService implements MediaAdministrationServiceInterface {

    protected basePath = 'http://localhost:8080/ServiceGateway/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param fileName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteMediaFile1(organization?: string, login?: string, fileName?: string, observe?: 'body', reportProgress?: boolean): Observable<DeleteMediaResponse>;
    public deleteMediaFile1(organization?: string, login?: string, fileName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DeleteMediaResponse>>;
    public deleteMediaFile1(organization?: string, login?: string, fileName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DeleteMediaResponse>>;
    public deleteMediaFile1(organization?: string, login?: string, fileName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (fileName !== undefined && fileName !== null) {
            queryParameters = queryParameters.set('fileName', <any>fileName);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<DeleteMediaResponse>(`${this.basePath}/media/delete`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param fileName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadMediaFile1(organization?: string, login?: string, fileName?: string, observe?: 'body', reportProgress?: boolean): Observable<DownloadMediaFileResponse>;
    public downloadMediaFile1(organization?: string, login?: string, fileName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DownloadMediaFileResponse>>;
    public downloadMediaFile1(organization?: string, login?: string, fileName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DownloadMediaFileResponse>>;
    public downloadMediaFile1(organization?: string, login?: string, fileName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (fileName !== undefined && fileName !== null) {
            queryParameters = queryParameters.set('fileName', <any>fileName);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<DownloadMediaFileResponse>(`${this.basePath}/media/download`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editMediaMetadata1(organization?: string, login?: string, body?: MediaFile, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public editMediaMetadata1(organization?: string, login?: string, body?: MediaFile, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public editMediaMetadata1(organization?: string, login?: string, body?: MediaFile, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public editMediaMetadata1(organization?: string, login?: string, body?: MediaFile, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Response>(`${this.basePath}/media/edit`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMediaLanguages1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<MediaLanguagesResponse>;
    public getMediaLanguages1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MediaLanguagesResponse>>;
    public getMediaLanguages1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MediaLanguagesResponse>>;
    public getMediaLanguages1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<MediaLanguagesResponse>(`${this.basePath}/media/languages`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrganizationMediaFiles1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetMediaFilesResponse>;
    public getOrganizationMediaFiles1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetMediaFilesResponse>>;
    public getOrganizationMediaFiles1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetMediaFilesResponse>>;
    public getOrganizationMediaFiles1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetMediaFilesResponse>(`${this.basePath}/media/organization`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceNumber 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getServiceNumberMediaFiles1(serviceNumber: string, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetMediaFilesResponse>;
    public getServiceNumberMediaFiles1(serviceNumber: string, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetMediaFilesResponse>>;
    public getServiceNumberMediaFiles1(serviceNumber: string, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetMediaFilesResponse>>;
    public getServiceNumberMediaFiles1(serviceNumber: string, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (serviceNumber === null || serviceNumber === undefined) {
            throw new Error('Required parameter serviceNumber was null or undefined when calling getServiceNumberMediaFiles1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetMediaFilesResponse>(`${this.basePath}/media/serviceNumber/${encodeURIComponent(String(serviceNumber))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public uploadMultipartForm1(organization?: string, login?: string, body?: MediaFileForm, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public uploadMultipartForm1(organization?: string, login?: string, body?: MediaFileForm, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public uploadMultipartForm1(organization?: string, login?: string, body?: MediaFileForm, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public uploadMultipartForm1(organization?: string, login?: string, body?: MediaFileForm, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/media/uploadMultipartForm`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public uploadMultipartFormDataInput1(organization?: string, login?: string, body?: MultipartFormDataInput, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public uploadMultipartFormDataInput1(organization?: string, login?: string, body?: MultipartFormDataInput, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public uploadMultipartFormDataInput1(organization?: string, login?: string, body?: MultipartFormDataInput, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public uploadMultipartFormDataInput1(organization?: string, login?: string, body?: MultipartFormDataInput, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/media/uploadMultipartFormDataInput`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
